import { createFileRoute } from '@tanstack/react-router'
import { CollectionDashboard } from '../../../../features/admin/CollectionDashboard'

/* ───── Route Definition ───── */

export const Route = createFileRoute('/_authenticated/admin/collection/')({
  component: AdminCollectionIndexRoute,
})

/* ───── Route Component ───── */

function AdminCollectionIndexRoute() {
  return <CollectionDashboard />
}
